import { without, find } from 'lodash';

export class ModalsHandlerServiceNg2 {
    private modals: any[] = [];

    add(modal: any) {
        // add modal to array of active modals
        this.modals.push(modal);
    }

    remove(idOfModalToRemove: string) {
        // remove modal from array of active modals
        let modalToRemove = find(this.modals, (currentId) => { return currentId === idOfModalToRemove; });
        this.modals = without(this.modals, modalToRemove);
    }

    open(idOfModalToOpen: string) {
        // open modal specified by idOfModalToOpen
        let modal = find(this.modals, (currentId) => { return currentId === idOfModalToOpen; });
        modal.open();
    }

    close(idOfModalToClose: string) {
        // close modal specified by idOfModalToClose
        let modal = find(this.modals, (currentId) => { return currentId === idOfModalToClose; });
        modal.close();
    }
}


/** WEBPACK FOOTER **
 ** ./src/common/modal/ng2/SimplaexModalsHandlerServiceNg2.ts
 **/